/**
 * Created two interfaces since Product will hold more properties and ProductReference is
 * used in all other documents referring to the experience/product.
 */
import { ProductCatalog } from "./Catalog";
import { ExperienceStatus } from "./Experience";
import { Media } from "./Media";
import { UnitType } from "./Unit";
import { WaiverExperiencePreference } from "./Waiver";

export enum UserDetailsRequirement {
    REQUIRED = "required",
    OPTIONAL_CONFIRMATION = "optional_confirmation",
    OPTIONAL_NO_CONFIRMATION = "optional_no_confirmation",
    NOT_COLLECTED = "not_collected",
}

export interface Product {
    id: ID;
    name: string;
    seller: { id: ID };
    object: ProductObject;
    medias?: Media[];
    photo?: Media;
    waiverPreference?: WaiverExperiencePreference;
    catalog?: ProductCatalog;
    status?: ExperienceStatus;
    baseGiftProduct?: boolean;
    system?: boolean;
    supportedCatalogItemTypes?: UnitType[];
    customerNamePreference?: UserDetailsRequirement;
}

export interface ProductReference {
    id: ID;
    name?: string;
    object?: ProductObject;
}

export enum ProductObject {
    PACKAGE = "package",
    PARTNER_PACKAGE = "partner_package",
    EXPERIENCE = "experience",
    COMBO = "combo",
    MEMBERSHIP = "membership",
    GIFT_OFFER = "gift_offer",
    WARE = "ware",
    COLLECTION = "collection",
}

export const productMap = {
    [ProductObject.GIFT_OFFER]: "giftOffers",
    [ProductObject.PARTNER_PACKAGE]: "partnerPackages",
    [ProductObject.EXPERIENCE]: "experiences",
    [ProductObject.PACKAGE]: "packages",
    [ProductObject.MEMBERSHIP]: "memberships",
    [ProductObject.COMBO]: "combos",
    [ProductObject.WARE]: "wares",
    [ProductObject.COLLECTION]: "collectionNodes",
};

export const productTitleMap: Record<ProductObject, string> = {
    [ProductObject.EXPERIENCE]: "Experiences",
    [ProductObject.PACKAGE]: "Packages",
    [ProductObject.PARTNER_PACKAGE]: "Partner Packages",
    [ProductObject.GIFT_OFFER]: "Gift Offers",
    [ProductObject.MEMBERSHIP]: "Memberships",
    [ProductObject.COMBO]: "Combos",
    [ProductObject.WARE]: "Merchandise", // User facing string is 'merchandise'
    [ProductObject.COLLECTION]: "Collections",
};

export const ALL_PRODUCT_OBJECTS = Object.values(ProductObject);

export type ListingType = ProductObject.PACKAGE | ProductObject.EXPERIENCE;
